import { REPORTS_STOCK_TRANSFER } from "../../framework/tab/tabUtilsConstants";
import moment from "moment";

export const columnDefs = [
  {
    headerName: "Stock Transfer Id",
    field: "stockTransferId", 
    locked: true,
    hide: false,
    cellClass: "custom-ag-cell-link",
    width: 150,
    suppressMovable: true,
  },
  {
    headerName: "From Branch Id",
    field: "fromBranchId", 
    locked: true,
    hide: false,
    width: 150,
  },
  {
    headerName: "To Branch Id",
    field: "branchId", 
    locked: true,
    hide: false,
    width: 150,
  },
  {
    headerName: "Business Date",
    field: "businessDate", 
    locked: true,
    hide: false,
    width: 200,
    filter: "agDateColumnFilter",
    valueFormatter: (params) => moment(params.value).format('DD/MM/YYYY hh:mm A'),
  },
  {
    headerName: "Amount",
    field: "amount", 
    locked: false,
    hide: false,
    cellClass: "custom-ag-cell-numeric",
    width: 120,
    showTotal: true,
  },
  {
    headerName: "Status",
    field: "status",
    locked: false,
    hide: false,
    width: 150,
  },
  {
    headerName: "Fullfillment Status",
    field: "fullfillmentStatus",
    locked: false,
    hide: false,
    width: 180,
    resizable: true,
  },
  {
    headerName: "Reason",
    field: "reason",
    locked: false,
    hide: false,
    width: 250,
    resizable: true,
  },
  {
    headerName: "Remarks",
    field: "remarks", 
    locked: false,
    hide: false,
    width: 250,
    resizable: true,
  },
  {
    headerName: "Transfer Type",
    field: "transferType", 
    locked: false,
    hide: true,
    width: 150,
  },
  {
    headerName: "User",
    field: "createdBy", 
    locked: false,
    hide: true,
    width: 100,
  },
];
export const columnDefsFunctions = {
  businessDate: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  status: {
    cellStyle: (params) => {
      return {
        borderRight: "1px solid #a0a0a0",
        ...(params.value === "ACCEPTED" && { color: 'green' }),
        ...(params.value === "REJECTED" && { color: 'red' }),
        ...(params.value !== "ACCEPTED" && params.value !== "REJECTED" && { color: 'black' }),
      };
    },
  },
};

export const initial_state_stock_transfer_report = {
  type: REPORTS_STOCK_TRANSFER,
  label: "Stock Transfer Report",
  allowMultipleTabs: false,
};
